module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u_Feature-Testimonial_Muhamad-Jazli-Adam-59101b3b3ba361f043635641bccd69ac.jpg";